import styled from 'styled-components';
import { Grid, theme } from '@dls/web';

export const SkeletonWrapper = styled(Grid)`
  position: absolute;
  background: white;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;
